import React, { useEffect, useState } from 'react';
import List from "./List.js";
import Modal from "../../Modals/Modal.js";
import { BACKEND_URL } from '../../consts';

const Faq = ({data}) => {
    const [openIndexes, setOpenIndexes] = useState([]);
    

  const toggleFAQ = (index) => {
    if (openIndexes.includes(index)) {
      setOpenIndexes(openIndexes.filter((i) => i !== index));
    } else {
      setOpenIndexes([...openIndexes, index]);
    }
  };
  

  const flagRussia = '/img/modal/russia.png';
  const flagChina = '/img/modal/china.png';
  const countries = [
      { code: '+7', flag: flagRussia, name: 'Россия' },
      { code: '+86', flag: flagChina, name: 'Китай' },
  ];





  const [selectedCountry, setSelectedCountry] = useState(countries[0]);
      const [isDropdownOpen, setIsDropdownOpen] = useState(false);
      const [name, setName] = useState('');
      const [phone, setPhone] = useState('+7');
      const [comment, setComment] = useState('');
      const [errors, setErrors] = useState({ name: '', phone: '' });
      const [letters, SetLetters] = useState(false)
  
  
      const handleCountrySelect = (country) => {
          setSelectedCountry(country);
          setPhone(country.code); 
          setIsDropdownOpen(false); 
      };
  
      const toggleDropdown = () => {
          setIsDropdownOpen(!isDropdownOpen);
      };
  
      const validateForm = () => {
          let valid = true;
          const newErrors = { name: '', phone: '' };
  
          if (!/^[a-zA-Zа-яА-ЯёЁ\s]+$/.test(name)) {
              newErrors.name = 'Имя должно содержать только буквы';
              valid = false;
          }
  
          const phoneRegex = /^(\+7|7|8|\+86|86)[\d\s\-()]*$/; 
          if (!phoneRegex.test(phone)) {
              newErrors.phone = 'Неверный номер телефона';
              valid = false;
          }
  
          setErrors(newErrors);
          return valid;
      };
  
      const handleSubmit = (e) => {
          e.preventDefault();
  
          if (validateForm()) {
              fetch(`${BACKEND_URL}/api/v1/calculator/contact`, {
                  method: 'POST',
                  headers: {
                      'Content-Type': 'application/json',
                  },
                  body: JSON.stringify({
                      name: name,
                      phone: phone,
                      comment: comment
                  }),
              })
              .then(response => {
                  if (!response.ok) {
                      throw new Error('Network response was not ok ' + response.statusText);
                  }
                  return response.json();
              })
              .then(data => {
                  console.log('Success:', data);
                  alert("Спасибо за ваш вопрос! Мы скоро с вами свяжемся.");
              })
              .catch((error) => {
                  console.error('Error:', error);
              });
          }
      };
  
      const handleNameChange = (e) => {
          setName(e.target.value);
          if (errors.name) {
              validateForm();
          }
      };
  
      const handlePhoneChange = (e) => {
          const inputValue = e.target.value;
  
          // Проверяем, содержит ли ввод буквы
          if (/[a-zA-Zа-яА-ЯёЁ]/.test(inputValue)) {
              SetLetters(true);
          }else{
              SetLetters(false)
          }
  
          // Проверяем, начинается ли ввод с кода страны
          if (inputValue.startsWith('+7') || inputValue.startsWith('7') || inputValue.startsWith('8')) {
              setSelectedCountry(countries[0]); // Россия
          } else if (inputValue.startsWith('+86') || inputValue.startsWith('86')) {
              setSelectedCountry(countries[1]); // Китай
          } else if (!/^\d|\+/.test(inputValue) || letters) {
              // Если строка не начинается с цифры и не с +, или если есть буквы, разрешаем свободный ввод
              setPhone(inputValue);
              return; // Выходим, чтобы не очищать ошибки
          }
  
          const onlyDigits = inputValue.replace(/[^0-9+() -]/g, ''); // Убираем все кроме цифр и символов
          setPhone(onlyDigits);
          setErrors((prev) => ({ ...prev, phone: '' }));
        }

  return (
    <div className="h-fit w-[98%] mx-auto leading-tight font-manrope font-medium">
      <div className="m-5 p-5 bg-gray-200 flex xs:flex-row flex-col justify-between rounded-2xl lg:gap-16 gap-8">
        <div className="flex flex-col xs:w-[55%] w-[100%]">
            <h2 className={`lg:text-[40px] xs:text-[36px] text-[28px] text-[${data.title_color}] mb-3 lg:mt-8 xs:mt-[20px]`}>
              {data.title}
            </h2>
            <div>
                {data.question_list.map((list, index) => (
                <List
                    key={index}
                    question={list.question}
                    answer={list.answer}
                    IsOpen ={openIndexes.includes(index)}
                    onClick={() => toggleFAQ(index)}
                    plus={list.plus}
                    minus_white={list.minus_white}
                    border_color={list.border_color}
                    hr_color={list.hr_color}
                />
                ))}
            </div>
        </div>
        {/* <Modal
          bg_color={data.form.bg_color}
          text_color={data.form.text_color}
          title={data.form.title}
          description={data.form.description}
          arrow={data.form.arrow}
          arrow_daun={data.form.arrow_daun}
          russia_flag={data.form.russia_flag}
          usa_flag={data.form.usa_flag}
          thailand_flag={data.form.thailand_flag}
          china_flag={data.form.china_flag}
          button_color={data.form.button_color}
          btn_hover_bg={data.form.btn_hover_bg}
          btn_active_bg={data.form.btn_active_bg}
          placeholder_color={data.form.placeholder_color}
          label_text1={data.form.label_text1}
          placeholder_text1={data.form.placeholder_text1}
          label_text2={data.form.label_text2}
          placeholder_text2={data.form.placeholder_text2}
          label_text3={data.form.label_text3}
          placeholder_text3={data.form.placeholder_text3}
          button_text_color={data.form.button_text_color}
          button_text={data.form.button_text}
          border={data.form.border}
        /> */}

              <div className="lg:min-w-[500px] xs:min-w-[320px] xs:w-[50%] min-w-[300px] ">
                <div className='rounded-2xl lg:p-[40px] xs:p-[20px] p-[20px] w-full bg-white'>
                  <h2 className="text-[32px] font-medium  mb-2 text-[28px] sm:text-[40px]">Остались вопросы?</h2>
                  <p className=" text-gray-600 mb-6">Оставьте свои контакты и наши менеджеры свяжутся с вами в течении часа</p>
                  <form className="flex flex-col gap-3" onSubmit={handleSubmit}>
                      <div className={`flex flex-col border-solid border-[#C9CED2] border-[1px] p-3 rounded-[16px] py-[15px] px-[20px] ${errors.name ? 'border-red-500' : ''}`}>
                          <span className="text-gray-600" style={{ fontSize: '14px' }}>Ваше имя</span>
                          <input 
                              type="text" 
                              placeholder="Иван" 
                              className={`rounded-lg text-[20px] text-gray-700 outline-none`} 
                              value={name}
                              onChange={handleNameChange}
                          />
                      </div>
                      <div className={`relative flex py-5 items-center gap-3 border-solid border-[#C9CED2] border-[1px] p-3 rounded-[16px] py-[15px] px-[20px] ${errors.phone ? 'border-red-500' : ''}`}>
                          <div className={`relative ${letters ? 'hidden' : 'block'}`}>
                              <button 
                                  type="button" 
                                  onClick={toggleDropdown} 
                                  className="flex items-center gap-1  rounded-lg p-1 w-[60px] h-[32px] text-lg text-gray-700 focus:outline-none"
                              >
                                  <img src={selectedCountry.flag} alt={selectedCountry.name} className="w-[32px] h-[32px] object-cover" />
                                  <img src="/img/modal/strelkaDaun.png" />
                              </button>
                              {isDropdownOpen && (
                                  <div className="absolute z-10 bg-white border  min-w-[200px]  rounded-lg shadow-lg mt-1 w-fit">
                                      {countries.map((country, index) => (
                                          <button
                                              key={index}
                                              type="button"
                                              onClick={() => handleCountrySelect(country)}
                                              className="flex items-center w-full text-left p-2 hover:bg-gray-300"
                                          >
                                              <img src={country.flag} alt={country.name} className="w-[20px] h-[20px] mr-2" />
                                              {country.name}
                                          </button>
                                      ))}
                                  </div>
                              )}
                          </div>
                          <div className="flex flex-col">
                              <span className="text-gray-600" style={{ fontSize: '14px' }}>Ваш телефон/Telegram</span>
                              <input 
                                  type="text" 
                                  value={phone}
                                  onChange={handlePhoneChange} 
                                  className={`border-none outline-none w-full bg-transparent text-[20px] text-gray-700`} 
                              />
                          </div>
                      </div>
                      <div className="flex flex-col border-solid border-[#C9CED2] border-[1px] p-3 rounded-[16px] py-[15px] px-[20px]">
                          <span className="text-gray-600" style={{ fontSize: '14px' }}>Комментарий</span>
                          <textarea 
                              placeholder="Опишите ваш вопрос" 
                              className="rounded-lg text-[20px] text-gray-700 outline-none min-h-[60px] mt-2 max-h-[120px]" 
                              value={comment}
                              onChange={(e) => setComment(e.target.value)}
                          ></textarea>
                      </div>
                      <button
                          type="submit"
                          className="bg-red-600 hover:bg-red-700 text-white font-bold py-4 px-6 mt-6 rounded-full flex justify-between items-center">
                          <span>Перезвоните мне</span>
                          <img src="/img/modal/strelka.png" alt="Стрелка" className="ml-2" />
                      </button>
                  </form>
                </div>
            </div>

      </div>
      
      
    </div>
  );
};

export default Faq;
